"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleTypes = void 0;

var _type = require("../../type");

var StyleTypes = (0, _type.tuple)('block-hover', 'hover', 'active');
exports.StyleTypes = StyleTypes;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud-fe/react-components/lib/components/Breadcrumb/interface.js
// module id = 1816
// module chunks = 6 7 17 18